import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationMemberQueryVariables = Types.Exact<{
  memberId: Types.Scalars['String']['input'];
}>;


export type OrganisationMemberQuery = { __typename?: 'Query', organisationMember: { __typename?: 'OrganisationMemberUser', id: string, role: Types.OrganisationRole, user: { __typename?: 'User', id: string, username: string, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, info?: string | null, superPals: Array<{ __typename?: 'User', id: string }> } } };


export const OrganisationMemberDocument = gql`
    query OrganisationMember($memberId: String!) {
  organisationMember(id: $memberId) {
    id
    role
    user {
      id
      username
      firstName
      lastName
      photoUrl
      info
      superPals {
        id
      }
    }
  }
}
    `;

/**
 * __useOrganisationMemberQuery__
 *
 * To run a query within a React component, call `useOrganisationMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useOrganisationMemberQuery(baseOptions: Apollo.QueryHookOptions<OrganisationMemberQuery, OrganisationMemberQueryVariables> & ({ variables: OrganisationMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationMemberQuery, OrganisationMemberQueryVariables>(OrganisationMemberDocument, options);
      }
export function useOrganisationMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationMemberQuery, OrganisationMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationMemberQuery, OrganisationMemberQueryVariables>(OrganisationMemberDocument, options);
        }
// @ts-ignore
export function useOrganisationMemberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationMemberQuery, OrganisationMemberQueryVariables>): Apollo.UseSuspenseQueryResult<OrganisationMemberQuery, OrganisationMemberQueryVariables>;
export function useOrganisationMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMemberQuery, OrganisationMemberQueryVariables>): Apollo.UseSuspenseQueryResult<OrganisationMemberQuery | undefined, OrganisationMemberQueryVariables>;
export function useOrganisationMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMemberQuery, OrganisationMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationMemberQuery, OrganisationMemberQueryVariables>(OrganisationMemberDocument, options);
        }
export type OrganisationMemberQueryHookResult = ReturnType<typeof useOrganisationMemberQuery>;
export type OrganisationMemberLazyQueryHookResult = ReturnType<typeof useOrganisationMemberLazyQuery>;
export type OrganisationMemberSuspenseQueryHookResult = ReturnType<typeof useOrganisationMemberSuspenseQuery>;
export type OrganisationMemberQueryResult = Apollo.QueryResult<OrganisationMemberQuery, OrganisationMemberQueryVariables>;